import { COLOR, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const SecTagListWrapper = styled.section<{ arrayLength: number }>`
  display: grid;
  grid-template-columns: ${({ arrayLength }) => arrayLength && `repeat(${arrayLength}, 1fr)`};
  grid-gap: 8px;

  ${mq.sp} {
    grid-gap: 0px;
  }
`;

export const ButtonTag = styled.button<{ isSelected: boolean }>`
  border-radius: 20px;
  font-size: 14px;
  text-align: center;
  padding: 0px 16px;
  height: 40px;

  ${mq.sp} {
    padding: 0px 8px;
    font-size: 12px;
    height: 32px;
  }

  ${({ isSelected }) =>
    isSelected
      ? `
          white-space: nowrap;
          background-color: ${COLOR.GRAY200.code};
        `
      : `
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `}
`;
